import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CountryToken, EnvToken, LanguageToken } from '@app/core/env.tokens';

/**
 * Adds `HH-Country` / `HH-Language` headers to requests hitting the
 * Handyhand APIs, mirroring the platform (handyhand-web) interceptor so the
 * backend can localize its responses. Values come from the host-resolved
 * tokens, so SSR and browser send the same headers for a given request.
 */
export const localizationInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(EnvToken);
  const country = inject(CountryToken);
  const language = inject(LanguageToken);

  const isHandyhandApiRequest =
    req.url.startsWith(env.apiUrl) || req.url.startsWith(env.vectorServiceUrl);

  if (!isHandyhandApiRequest) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'HH-Country': country,
        'HH-Language': language,
      },
    }),
  );
};
